var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents7" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contents" }, [
      _c("p", { staticClass: "text1" }, [
        _vm._v("\n      누적 100,000건"),
        _c("br"),
        _vm._v("\n      카수리 100% 리얼 후기!\n    ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text2" }, [
        _vm._v("\n      카수리 이용자들이 직접 쓴 후기와 평점."),
        _c("br"),
        _vm._v("\n      평균 고객만족도 4.9/5\n    ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a869c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a869c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents7.vue
// module id = null
// module chunks = 